module.exports = __webpack_public_path__ + "img/cv.c4df14e.svg";